import React from "react"

const TButtonOrder = () => {
    return (
        <button
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 6px 12px rgba(0,0,0,0.3)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
            }}
            style={{
                backgroundColor:'#0dcaf0',
                borderColor:'#0dcaf0',
                marginTop:15,
                boxShadow: "0 4px 8px rgba(0,0,0,0.2)",      // hiệu ứng nổi nhẹ
                transition: "all 0.2s ease-in-out",           // mượt khi hover
            }} type="button" className="btn btn-dark rounded-pill" >
            <a
                href={"https://zalo.me/4354315060256721375"}
                target={"_blank"}><span style={{ color: 'black', fontWeight:'bold', fontSize: 13 }}>Tư vấn đặt hàng</span></a>
        </button>
    )
}

export default React.memo(TButtonOrder);
